import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Toaster } from "react-hot-toast";
import { TpnRoutes } from "../../data";
import { useTpnDetailsQuery } from "../../services/tpnApi";
import WareHouseDW from "../Common/CustomSelect/WareHouseDW";
import Header from "../Common/Header/Header";
import LoadingModal from "../Common/Modal/LoadingModal";
import ExportNav from "../Common/Nav/ExportNav";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";

function TPNDetails() {
  // Date
  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  //   const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [exportData, setExportData] = useState([]);
  const [aamarId, setAamarId] = useState("");
  const [warehouse, setWarehouse] = useState("allWh");
  const [loader, setLoader] = useState(true);
  const auth = signInUser();
  const { storeSettings } = auth;

  const { data, isSuccess, refetch } = useTpnDetailsQuery({
    startDate,
    endDate,
    warehouse,
    aamarId,
  });

  useEffect(() => {
    refetch();
  }, [startDate, endDate, warehouse, aamarId]);

  useEffect(() => {
    if (auth?.type === "admin") {
      setWarehouse("allWh");
    } else {
      setWarehouse(auth?.warehouse);
    }
  }, []);
  useEffect(() => {
    setAamarId(auth?.aamarId);
  }, []);

  useEffect(() => {
    setLoader(false);
    if (data?.products?.length > 0) {
      setExportData(data.products);
    }
  }, [isSuccess, data]);

  const handleLoaderClose = () => setLoader(false);

  const handleOnchangeWareHouseFrom = (e) => {
    if (e.option !== "no-warehouse") {
      setWarehouse(e.option);
    } else {
      setWarehouse("allWh");
    }
  };
  const preHeader = [
    [`${storeSettings?.storeName || "No-Name"}`],
    [`${storeSettings?.address?.street || "No-Street"}`],
    [
      `${storeSettings?.address?.city || "No-City"}-${
        storeSettings?.address?.post || "No-PostalCode"
      }`,
    ],
    [
      `For the Period: ${format(new Date(startDate), "MM-dd-yyyy")} to ${format(
        new Date(endDate),
        "MM-dd-yyyy"
      )}`,
    ],
    ["TPN Details Report"],

    [], // Empty row for spacing
  ];
  return (
    <div>
      <div className="container-fluid ">
        <LoadingModal
          title={"Please Wait"}
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title="Tpn Details by Article"></Header>
            <div className="row mt-3">
              <div className="col-md-6">
                {/* Sort date range */}
                <div className="date-picker d-flex  mb-2 align-items-center gap-2">
                  {/* <b>Start:</b> */}
                  <DatePicker
                    selected={new Date(startDate)}
                    className="form-control me-2"
                    onChange={(date) =>
                      setStartDate(format(new Date(date), "MM-dd-yyyy"))
                    }
                  />
                  <span width="10px"></span>
                  {/* <b>End:</b> */}
                  <DatePicker
                    selected={new Date(endDate)}
                    className="form-control"
                    onChange={(date) =>
                      setEndDate(format(new Date(date), "MM-dd-yyyy"))
                    }
                  />
                  {auth?.type === "admin" && (
                    <div
                      className="mt-2 mt-md-0 mb-2 mb-md-0 "
                      style={{
                        width:
                          window.innerWidth >= 1024
                            ? 280
                            : window.innerWidth >= 768
                            ? 280
                            : "100%", // Adjust width based on screen size
                      }}
                    >
                      <WareHouseDW
                        id="warehouse"
                        name="warehouse"
                        handleOnChange={handleOnchangeWareHouseFrom}
                        className="form-control "
                      />
                    </div>
                  )}
                  {/* Search */}
                  {/* <input
                    className="form-control"
                    name="search"
                    type="Search"
                    onChange={(e) => setSearch(e.target.value)}
                  />*/}
                </div>
              </div>
              <div className="col-md-6">
                <span className="float-end">
                  <ExportNav
                    preheader={preHeader}
                    Routes={TpnRoutes}
                    title="RTV Details"
                    data={exportData}
                  />
                </span>
              </div>
            </div>
            <Table striped bordered hover className="text-sm">
              <thead>
                <tr>
                  <th>TPN No</th>
                  {/* <th>Supplier</th> */}
                  <th className="text-center">Aricle Code</th>
                  <th>Name</th>
                  {/* <th className="text-center">warehouse</th> */}
                  <th className="text-center">TP</th>
                  <th>QTY</th>
                  <th className="text-center">Unit</th>
                  <th className="text-end">Stock Value</th>
                </tr>
              </thead>
              <tbody>
                {data?.products?.length > 0 ? (
                  data?.products?.map((tpn) => (
                    <tr key={tpn.name}>
                      <td>{tpn.tpnNo}</td>
                      <td className="text-center">{tpn.article_code}</td>
                      <td>{tpn.name}</td>
                      {/* <td>{tpn.warehouse}</td> */}
                      <td className="text-center">{tpn.tp} </td>
                      <td>
                        <b>{parseFloat(tpn.qty)} </b>
                        {/* {`[${tpn?.unit}]`} */}
                      </td>
                      <td className="text-center">{tpn.unit}</td>
                      <td className="text-end">
                        <b>{new Intl.NumberFormat().format(tpn.stockValue)} </b>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr colSpan={7}>No Product Found</tr>
                )}
                <tr>
                  <td className="text-end" colSpan={6}>
                    <b>TOTAL VALUE:</b>
                  </td>
                  <td className="text-end">
                    <b>{new Intl.NumberFormat().format(data?.stockValue)}</b>
                  </td>
                </tr>
              </tbody>
            </Table>
            {/* pagination */}
            {/* <ProductDataTable></ProductDataTable> */}
          </div>
        </div>
      </div>

      <Toaster position="bottom-right" />
    </div>
  );
}

export default TPNDetails;
